<template>
    <v-dialog persistent content-class="pro-dialog" v-model="addApidaeContactDialog" max-width="500px">
        <v-card>
            <v-card-title>
                <h2 class="headline-title" v-if="!isEditMode">Ajout d'un contact</h2>
                <h2 class="headline-title" v-else>Modification d'un contact</h2>

                <v-btn icon class="close-modal-icon" @click="closeDialog()">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-spacer></v-spacer>
                <div class="mt-3">
                    <form-component-loader :fields="fields" :data="currentApidaeContact"></form-component-loader>

                    <div class="mt-3" v-if="submitted">
                        <v-alert v-for="error in formErrors"
                                 type="error"
                                 class="mt-5 text-left">
                            {{ error.message }}
                        </v-alert>
                    </div>

                    <div class="text-center w-100 mt-3">
                        <v-btn class="text-none"
                               @click="addContact"
                               v-if="!isEditMode"
                               :color="primaryColor"
                               style="border-radius: 20px; color: white">
                            Ajouter
                        </v-btn>

                        <v-btn class="text-none"
                               v-else
                               @click="saveContact"
                               :color="primaryColor"
                               style="border-radius: 20px; color: white">
                            Enregistrer
                        </v-btn>
                    </div>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>

import {mapGetters, mapMutations, mapState} from "vuex"
import FormComponentLoader from "../../FormComponentLoader.vue"
import * as EmailValidator from 'email-validator'
import PhoneNumber from "awesome-phonenumber"

export default {
    name: "AddApidaeContactModal",
    props: ['fields'],
    components: {FormComponentLoader},
    data() {
        return {
            submitted: false
        }
    },
    methods: {
        ...mapMutations('web_form', ['setAddApidaeContactDialog', 'setCurrentApidaeContact', 'setContactTabDirty',]),
        closeDialog() {
            this.submitted = false

            this.setAddApidaeContactDialog(false)

            setTimeout(() => {
                this.setCurrentApidaeContact(null)
            }, 200)
        },
        saveContact() {
            this.submitted = true

            if (this.isFormValid) {
                this.provider.contacts.forEach((contact, index) => {
                    if (contact.uid === this.currentApidaeContact.uid) {
                        this.$set(this.provider.contacts, index, this.currentApidaeContact)
                    }
                })

                this.setContactTabDirty(true)
                this.closeDialog()
            }
        },
        addContact() {
            this.submitted = true

            if(this.isFormValid) {
                this.provider.contacts.push(this.currentApidaeContact)

                this.setContactTabDirty(true)
                this.closeDialog()
            }
        },
        hasValidEmail(email) {
            return EmailValidator.validate(email)
        },
        hasValidPhone(phone) {
            if(phone !== null) {
                let phoneFr = new PhoneNumber(phone, 'FR')
                let phoneNc = new PhoneNumber(phone, 'NC')
                let phoneCa = new PhoneNumber(phone, 'CA')

                return phoneFr.isValid() || phoneNc.isValid() || phoneCa.isValid()
            }
        }
    },
    computed: {
        ...mapState('web_form', ['provider', 'addApidaeContactDialog', 'currentApidaeContact']),
        ...mapState('webFormStyle', ['primaryColor']),
        isEditMode() {
            if (this.currentApidaeContact === null) {
                return false
            }

            return this.provider.contacts.find(contact => contact.uid === this.currentApidaeContact.uid) !== undefined
        },
        formErrors() {
            let errors = []

            if (this.currentApidaeContact.email !== null && this.currentApidaeContact.email !== '' && !this.hasValidEmail(this.currentApidaeContact.email)) {
                errors.push({ message: 'Le format de l\'e-mail est incorrect.'})
            }

            if (this.currentApidaeContact.phone !== null && this.currentApidaeContact.phone !== '' && !this.hasValidPhone(this.currentApidaeContact.phone)) {
                errors.push({ message: 'Le format du numéro de téléphone est incorrect.'})
            }

            return errors
        },
        isFormValid() {
            return (this.currentApidaeContact.email === null || this.currentApidaeContact.email === '' || this.hasValidEmail(this.currentApidaeContact.email)) &&
                (this.currentApidaeContact.phone === null || this.currentApidaeContact.phone === '' || this.hasValidPhone(this.currentApidaeContact.phone))
        }
    }
}
</script>